import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
   apiKey: "AIzaSyD4lP8DqmF2O_H5zSLJuAadCwFC_rxawtw",
   authDomain: "bmschedule-48c29.firebaseapp.com",
   projectId: "bmschedule-48c29",
   storageBucket: "bmschedule-48c29.firebasestorage.app",
   messagingSenderId: "454452986696",
   appId: "1:454452986696:web:74a529e16acfbadda4697d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);